import { render } from "./EditButtons.vue?vue&type=template&id=1d79b398"
import script from "./EditButtons.vue?vue&type=script&lang=js"
export * from "./EditButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__